export default {
  'auth.loginHero': 'Your Vietnam adventure starts here',
  'auth.loginHeroText': 'Sign in to manage your bookings, save your favorite tours and continue planning the trip of a lifetime.',
  'auth.welcomeBack': 'Welcome back',
  'auth.signInContinue': 'Sign in to continue your journey.',
  'auth.resetPrompt': 'Enter your email to reset your password.',
  'auth.emailAddress': 'Email address',
  'auth.password': 'Password',
  'auth.forgotPassword': 'Forgot password?',
  'auth.rememberMe': 'Remember me',
  'auth.signingIn': 'Signing in...',
  'auth.signIn': 'Sign In',
  'auth.sending': 'Sending...',
  'auth.sendResetLink': 'Send Reset Link',
  'auth.backToSignIn': 'Back to sign in',
  'auth.noAccount': "Don't have an account?",
  'auth.signUp': 'Sign up',
  'auth.hidePassword': 'Hide password',
  'auth.showPassword': 'Show password',
  'auth.resetLinkSent': 'We sent a password reset link to your email. Please check your inbox.',
  'auth.somethingWentWrong': 'Something went wrong. Please try again.',
  'auth.sendOtp': 'Send OTP code',
  'auth.sendingOtp': 'Sending code...',
  'auth.otpSent': 'We sent a 6-digit verification code to your email. Please check your inbox.',
  'auth.otpSentShort': 'Enter the 6-digit code we sent to your email.',
  'auth.otpCode': 'Verification code',
  'auth.verifyOtp': 'Verify & sign in',
  'auth.verifySignUp': 'Verify & create account',
  'auth.verifying': 'Verifying...',
  'auth.resendOtp': 'Resend code',
  'auth.resendIn': 'Resend in {s}s',
  'auth.changeEmail': 'Change email',
  'auth.otpInvalid': 'Please enter a valid 6-digit code.',
  'auth.registerHero': 'Unforgettable journeys await',
  'auth.registerHeroText': 'Create an account to book tours, receive personalized recommendations and keep every memory in one place.',
  'auth.createAccount': 'Create your account',
  'auth.joinUs': 'Join us and start planning your perfect Vietnam trip.',
  'auth.fullName': 'Full name',
  'auth.yourFullName': 'Your full name',
  'auth.phoneNumber': 'Phone number',
  'auth.atLeast6': 'At least 6 characters',
  'auth.confirmPassword': 'Confirm password',
  'auth.reenterPassword': 'Re-enter your password',
  'auth.creatingAccount': 'Creating account...',
  'auth.terms': 'By signing up, you agree to our Terms of Service and Privacy Policy.',
  'auth.haveAccount': 'Already have an account?',
  'auth.passwordMin6': 'Password must be at least 6 characters long.',
  'auth.passwordMismatch': 'Passwords do not match.',
  'auth.accountCreated': 'Account created! Please check your email to confirm your registration.',
  'auth.resetHero': 'A fresh start to your journey',
  'auth.resetHeroText': 'Set a new password and get back to planning your perfect Vietnam adventure in no time.',
  'auth.resetTitle': 'Reset your password',
  'auth.checking': 'Checking your reset link...',
  'auth.chooseNew': 'Choose a new password for your account.',
  'auth.invalidLink': 'This reset link is invalid or has expired.',
  'auth.cantVerify': "We couldn't verify your reset link. It may have expired or already been used. Please request a new one.",
  'auth.continueSignIn': 'Continue to sign in',
  'auth.newPassword': 'New password',
  'auth.confirmNewPassword': 'Confirm new password',
  'auth.reenterNewPassword': 'Re-enter your new password',
  'auth.updating': 'Updating...',
  'auth.updatePassword': 'Update Password',
  'auth.passwordUpdated': 'Your password has been updated successfully.',
  'profile.loading': 'Loading your account...',
  'profile.signInToView': 'Sign in to view your account',
  'profile.manageText': 'Manage your bookings, saved tours and profile all in one place.',
  'profile.myAccount': 'My Account',
  'profile.welcomeBack': 'Welcome back! Manage your bookings and travel plans here.',
  'auth.emailPlaceholder': 'you@example.com',
  'auth.loginAlt': 'Ha Long Bay Vietnam at golden hour',
  'auth.loginTitle': 'Ha Long Bay Vietnam travel',
  'auth.registerAlt': 'Hoi An ancient town Vietnam at dusk',
  'auth.registerTitle': 'Hoi An Vietnam travel',
};